import { render, staticRenderFns } from "./SitePromoBanner.vue?vue&type=template&id=2d9c6062&scoped=true"
import script from "./SitePromoBanner.vue?vue&type=script&lang=ts"
export * from "./SitePromoBanner.vue?vue&type=script&lang=ts"
import style0 from "./SitePromoBanner.vue?vue&type=style&index=0&id=2d9c6062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c6062",
  null
  
)

export default component.exports